import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GtmService } from '../../../../shared/cardholders-core/services/gtm.service';
import { IBenefitPlusResult } from '../../models/benefit-plus-result';
import { a11yFix } from '../../../../shared/utils/a11y.utils';

@Component({
    selector: 'app-promoted-benefits',
    templateUrl: './promoted-benefits.component.html',
    styleUrls: ['./promoted-benefits.component.scss']
})
export class PromotedBenefitsComponent implements OnInit, AfterViewInit {
    @Input() promotedBenefits: IBenefitPlusResult[];
    @Output() openBenefit: EventEmitter<any> = new EventEmitter<any>();
    private swipeCoord?: [number, number];
    private swipeTime?: number;

    constructor(private gtmService: GtmService) { }
    ngAfterViewInit(): void {
        setTimeout(() => {

            a11yFix().dialog('.benfit-link', {
                selectors: {
                    dialog: '.search-box-container.search-open',
                    trigger: '.benfit-link',
                    closeBtn: '.close',  // relative to container
                    heading: '.main-title'  // relative to container
                },
            });
        }, 1000);
    }

    ngOnInit(): void {}

    benefitClick(benefit: IBenefitPlusResult) {
        this.openBenefit.emit(benefit);
    }

    swipe(e: TouchEvent, when: string): void {
        const coord: [number, number] = [e.changedTouches[0].pageX, e.changedTouches[0].pageY];
        const time = new Date().getTime();
        if (when === 'start') {
            this.swipeCoord = coord;
            this.swipeTime = time;
        } else if (when === 'end') {
            const direction = [coord[0] - this.swipeCoord[0], coord[1] - this.swipeCoord[1]];
            const duration = time - this.swipeTime;
            if (duration < 1000 && Math.abs(direction[0]) > 30 && Math.abs(direction[0]) > Math.abs(direction[1] * 3)) {
                const swipe = direction[0] < 0 ? 'right' : 'left';
                this.gtmService.pushNewBenefitPulsePageLobby('Swipe - ' + swipe);
            }
        }
    }
}
